import { defaultApiState } from '@/store/types/general.types';
import { CourseModuleState } from './course-module.types';

export const courseModuleState: CourseModuleState = {
  apiState: {
    createCourseModulesApi: defaultApiState,
    updateCourseModulesApi: defaultApiState,
    deleteCourseModulesApi: defaultApiState
  },
  courseModulesTabState: {
    activeCourseModules: [],
    deletedCourseModules: [],
    courseModuleFormHasError: false
  }
};
